import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _RefreshLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "m14 15-4 4 4 4" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5.938 15.5a7 7 0 1 1 5.01 3.42" })));
}
const RefreshLight = forwardRef(_RefreshLight);
export { RefreshLight };
